import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { PlusSquare } from 'react-bootstrap-icons';
import "bootstrap/js/src/collapse.js";
import { Link } from 'react-router-dom';
import FormattedDate from './FormattedDate';
import RelayBandwidth from './RelayBandwidth';
import RelayCountry from './RelayCountry';
import RelayFlag from './RelayFlag';

function RelaySummaryRow(props) {
  const relay = props.relay;
  const fingerprint = (relay.fingerprint ? relay.fingerprint : relay.hashed_fingerprint);
  return (
    <>
    <tr class={"table-" + (relay.running ? "light" : "danger")}>
      <td
        data-toggle="collapse"
        data-target={".relay-summary-collapse-" + fingerprint}
        aria-controls={"relay-summary-collapse-" + fingerprint}
        style={{"cursor": "pointer"}}
      ><PlusSquare/></td>
      <td><Link to={`/details/${fingerprint}`}>{relay.nickname}</Link> {" "}
        {props.type === "relay" && <>(<Link to={"/search/family:" + fingerprint}>{relay.effective_family.length}</Link>)</>}
      </td>
      <td className={relay.running ? "text-success" : "text-danger"}>
        {relay.running
          ? <FormattedDate date={relay.last_restarted} />
          : <FormattedDate date={relay.last_seen} />}</td>
      <td>
        {relay.country &&
        <Link title={relay.country_name} to={"/search/country:" + relay.country}>
          <RelayCountry country={relay.country} name={relay.country_name} />
        </Link>}
      </td>
      <td><Link to={"/search/as:" + relay.as}>{relay.as_name}</Link></td>
      <td>{relay.flags.map((flag) => (
        <RelayFlag
          flag={flag}
          key={flag}
        />
      ))}</td>
      <td>
        <RelayBandwidth
          advertised_bandwidth={relay.advertised_bandwidth}
          bandwidth_rate={relay.bandwidth_rate}
          bandwidth_burst={relay.bandwidth_burst}
          observed_bandwidth={relay.observed_bandwidth} />
      </td>
      <td>Relay</td>
    </tr>
    <tr className={"collapse relay-summary-collapse-" + fingerprint} id={"#relay-summary-collapse-" + fingerprint}>
      <td colSpan="8">
        <Container>
          <Row>
            <Col>
              <dl>
                <dt>Contact Information</dt>
                <dd>{relay.contact ? relay.contact : "(None)"}</dd>
                <dt>OR Address(es)</dt>
                <dd>{relay.or_addresses.join(", ")}</dd>
                <dt>Dir Address</dt>
                <dd>{relay.dir_address}</dd>
                <dt>Consensus Weight</dt>
                <dd>{relay.consensus_weight}</dd>
              </dl>
            </Col>
            <Col>
              <dl>
                <dt>Last Restarted</dt>
                <dd>{relay.last_restarted}</dd>
                <dt>Last Seen</dt>
                <dd>{relay.last_seen}</dd>
                <dt>First Seen</dt>
                <dd>{relay.first_seen}</dd>
                <dt>Platform</dt>
                <dd>{relay.platform ? relay.platform : "(None)"}</dd>
              </dl>
            </Col>
          </Row>
        </Container>
      </td>
    </tr>
    </>
  )
}

export default RelaySummaryRow;
